module.exports = __webpack_public_path__ + "img/Roadshow SMKN 4 Tangerang.bd66b111.jpg";